import React from 'react';
import config from 'config';
import history from '../../history';
import Table from 'components/table';
import {LinkSmall} from 'components/buttons';
import {statuses} from './statuses';


const MailsList = ({ mails }) => {
  const handleLinkClick = e => e.stopPropagation()

  return <Table black hover>
    <thead>
    <tr>
      <th>Номер документа</th>
      <th>Назва документа</th>
      <th>Термін виконання</th>
      <th>Стан</th>
      <th>Реакція</th>
    </tr>
    </thead>
    <tbody>
    {mails.map((item, i) => (
      <tr key={i} onClick={(event) => {
        event.preventDefault();
        history.push(`/admin/mailing/detail/${item.get('id')}`)}}>
        <td><span>Номер документа:</span>{item.get('document_list').size > 0 ? item.get('document_list').get(0).get('document_data').get('number') : item.get('id')}</td>
        {(Date.now() > new Date(item.get('time_deadline')) && (item.get('count_mailing_user_completed') < item.get('count_mailing_user'))) ?
          (<td style={{color: "#dd4b39"}}>
              <span>Назва документа:</span>
              {item.get('document_list').size > 0
                ? item.get('document_list').get(0).get('document_data').get('name')
                : "Назва розсилки"
              }
            </td>
          ):(
            <td >
              <span>Назва документа:</span>
              {item.get('document_list').size > 0
                ? item.get('document_list').get(0).get('document_data').get('name')
                : "Назва розсилки"
              }
            </td>
          )
        }
        <td><span>Термін виконання:</span>{new Date(item.get('time_deadline')).toLocaleString('uk-UA', config.options)}</td>
        <td><span>Стан:</span>{statuses[item.get('current_status')]}</td>
        <td><span>Реакція:</span>{item.get('count_mailing_user_completed')}/{item.get('count_mailing_user')}</td>
        <td><LinkSmall to={`/admin/mailing/detail/${item.get('id')}`} onClick={handleLinkClick}>Детальніше</LinkSmall></td>
      </tr>
    ))}
    </tbody>
  </Table>
}

export default MailsList;



// WEBPACK FOOTER //
// ./src/admin/mailing/mails-list.js